import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faTwitterSquare,
  faYoutubeSquare
} from "@fortawesome/free-brands-svg-icons";

const SocialMedia = () => {
  return (
    <ul className="list-inline mt-2">
      <li className="list-inline-item">
        <a
          target="_blank noopener noreferrer"
          href="https://twitter.com/nochesdesalsa"
        >
          <FontAwesomeIcon icon={faTwitterSquare} size="4x" />
        </a>
      </li>
      <li className="list-inline-item ml-2">
        <a
          target="_blank noopener noreferrer"
          href="http://www.facebook.com/pages/NOCHES-DE-SALSA/140924549266477"
        >
          <FontAwesomeIcon icon={faFacebookSquare} size="4x" />
        </a>
      </li>
      <li className="list-inline-item ml-2">
        <a
          target="_blank noopener noreferrer"
          href="http://www.youtube.com/user/NochesDeSalsaUK"
        >
          <FontAwesomeIcon icon={faYoutubeSquare} size="4x" />
        </a>
      </li>
    </ul>
  );
};

export default SocialMedia;
